module.exports = __webpack_public_path__ + "static/media/barbara.12931f52.png";